import React, { useState } from 'react';
import styles from './SearchInput.module.scss';
import Times from '../../Icons/Times';

export interface ISearchInput {
  id: string;
  ariaLabel: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  value: string;
  clearSearchButtonAriaLabel?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onArrowDown?:() => void;
}

export default function SearchInput({
  id,
  ariaLabel,
  onChange,
  placeholder = 'Search',
  value,
  clearSearchButtonAriaLabel = 'Click for clear search',
  inputRef,
  onArrowDown
}: ISearchInput) {
  const [isVisible, setVisible] = useState(true);
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.value.length > 0) setVisible(false);
    else setVisible(true);
    if (onChange != null) onChange(event.target.value);
  }

  function clear() {
    if (onChange != null) onChange('');
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>){
    if (event.key === 'ArrowDown' && onArrowDown != null) onArrowDown();
  }

  return (
    <div className={styles.inputContainer}>
      <input
        id={id}
        type="search"
        placeholder={placeholder}
        autoComplete="off"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={value}
        aria-label={ariaLabel}
        ref={inputRef}
      />
      <>
        {!isVisible && (
          <button
            type="button"
            className={styles.clearSearch}
            onClick={clear}
            aria-label={clearSearchButtonAriaLabel}
          >
            <Times />
          </button>
        )}
      </>
    </div>
  );
}
